module.exports = __WEBPACK_EXTERNAL_MODULE_5__;


//////////////////
// WEBPACK FOOTER
// external "hadron-react-components"
// module id = 5
// module chunks = 0